import React, { useEffect } from "react";
import Label from "../label";
import ErrorLabel from "../error-label";

import { Select } from "antd";
import { Icon } from "../icons";
import "./style.css";
import { ICountryPortPicker } from "src/types";
import useGetLazyPorts from "src/hooks/useGetLazyPorts";
import TextInput from "../text-input";
import useQueryParams from "src/hooks/useQueryParams";
import useGetLazyAreanames from "src/hooks/useGetLazyAreanames";

const LazyAreanameSelector = ({
  id,
  name,
  label,
  classes,
  placeholder,
  required = false,
  errorMessage = "",
  showError,
  onSelect,
  value,
  disabled,
  allowCustomValue = false,
  onChange,
  filterValue,
  initialSearchValue,
  port,
}: ICountryPortPicker) => {
  const { getQueryParam } = useQueryParams();
  const quotationId = getQueryParam("id") || "";

  const {
    areanames,
    loadNextPage,
    pagination,
    handleSearch,
    searchValue,
    setSearchValue,
  } = useGetLazyAreanames({ port });

  useEffect(() => {
    setSearchValue(quotationId ? initialSearchValue : "");
  }, [initialSearchValue]);

  const style = allowCustomValue
    ? { caretColor: "transparent", cursor: "pointer" }
    : {};

  if (allowCustomValue) {
    return (
      <div className={classes?.containerClassName}>
        {label && <Label id={id || name} name={label} required={required} />}

        <div className="portSelectWrapper">
          <TextInput
            name="email"
            type="email"
            label=""
            placeholder={placeholder}
            classes={{ containerClassName: "mb-12", inputClassName: "" }}
            value={value}
            onChange={(e: any) => {
              onChange(e.target.value);
            }}
            required={true}
            prefix={<Icon.McsIcMapPin />}
          />
        </div>

        {showError && (
          <ErrorLabel
            message={errorMessage}
            className={classes?.errorLabelClass}
          />
        )}
      </div>
    );
  }

  return (
    <div className={classes?.containerClassName}>
      {label && <Label id={id || name} name={label} required={required} />}

      <div className="portSelectWrapper">
        <div className="prefix-icon-wrapper">{<Icon.McsIcMapPin />}</div>
        <Select
          style={style}
          popupClassName="!bg-primary-50"
          rootClassName={
            allowCustomValue ? "custom-value-lazy-port-selector" : ""
          }
          placeholder={placeholder}
          size="large"
          className="w-full"
          value={value ? value : undefined}
          showSearch={true}
          disabled={disabled}
          optionLabelProp="label"
          loading={pagination?.isLoading}
          labelInValue={true}
          onChange={(value: any) => {
            onSelect(value);
          }}
          searchValue={searchValue}
          onSearch={(value: string) => {
            // setSearchValue(value);
            handleSearch(value); // Trigger backend search
          }}
          onPopupScroll={(e) => {
            const target = e.target as HTMLElement;
            if (
              target.scrollTop + target.clientHeight >= target.scrollHeight &&
              pagination.hasMore &&
              !pagination.isLoading
            ) {
              loadNextPage();
            }
          }}
          virtual={true}
          open={allowCustomValue ? false : undefined}
          allowClear={true}
          filterOption={false}
        >
          {areanames.map((item: any) => (
            <Select.Option
              // Use area name (unique per place). Zip alone is ambiguous in GR
              // when multiple areas share the same postcode (e.g. 23200).
              value={item.area_english}
              key={item.id ?? `${item.area_english}-${item.zip_code}`}
              label={`${item.area_english}${item.zip_code ? ` (${item.zip_code})` : ""}`}
            >
              <div className="flex flex-col gap-2" key={item.id}>
                <span className="!text-12 !font-medium !leading-18 !text-gray-700">
                  {item.area_english} ({item.area_local})
                </span>
                <span>
                  {item.zip_code}, {item.country_code}
                </span>
              </div>
            </Select.Option>
          ))}
        </Select>
      </div>

      {showError && (
        <ErrorLabel
          message={errorMessage}
          className={classes?.errorLabelClass}
        />
      )}
    </div>
  );
};

export default LazyAreanameSelector;
